<template>
  <div class="padres-container">
    <!-- Texto nombres novios -->


    <!-- Ornamento con animación 
    <div ref="ornamentoRef" class="ornamento-container">
      <img src="@/assets/ornamiento2.png" alt="Ornamento decorativo" class="ornamento-img" />

    </div>--><br><br><br><br>
    <div class="decorative-line"></div> <!-- Línea fina debajo del ornamento -->
<br>
    <!-- Texto bendición alineado a la izquierda -->
    <div class="bendicion-container-izq">
      <p class="bendicion-subtitulo">Con la bendición de Dios y</p>
      <p class="bendicion-titulo">Nuestros Padres</p>
    </div>

    <!-- Fondo y overlay -->
      <div class="overlay"></div>

      <!-- Fotos padres -->
      <div class="padres-fotos-container">
        <!-- Padres de la Novia -->
        <div ref="padre1Ref" class="padre-card left">
          <p class="padre-nombres"> Jorge Humberto Salinas López  <br> & <br>Irma Barrientos Tovar </p>
          <div class="padre-label">PADRES DE LA NOVIA</div>
        </div>

        <!-- Padres del Novio -->
        <div ref="padre2Ref" class="padre-card right">
          <p class="padre-nombres"> Epifanio Mendoza Lozano <br> & <br> María Cecilia Burnias Cabello  </p>
          <div class="padre-label">PADRES DEL NOVIO</div>
        </div>
      </div>
    </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';

export default {
  name: 'BienvenidaPadresPage',
  setup() {
    const texto0Ref = ref(null);
    const padre1Ref = ref(null);
    const padre2Ref = ref(null);
    const ornamentoRef = ref(null);

    const observeElement = (element, direction = 'X') => {
      if (element.value) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                element.value.classList.add('animate__animated', direction === 'Y' ? 'animate__fadeInDown' : 'animate__fadeInUp');
                element.value.style.opacity = '1';
                element.value.style.transform = 'translateY(0)';
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.1 }
        );
        observer.observe(element.value);
      }
    };

    onMounted(async () => {
      await nextTick();
      observeElement(texto0Ref, 'Y');
      observeElement(ornamentoRef, 'Y');
      observeElement(padre1Ref);
      observeElement(padre2Ref);
    });

    return {
      texto0Ref,
      padre1Ref,
      padre2Ref,
      ornamentoRef
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Dancing+Script&family=Playfair+Display&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css');

@font-face {
  font-family: 'Starlove';
  src: url('@/assets/fonts/starlove.ttf') format('truetype');
}

.padres-container {
  width: 100%;
  text-align: center;
  background-image: url('@/assets/i3.png');
  background-size: cover;
  background-position: center;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Texto novios */
.texto-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.6s ease;
  width: 90%;
  margin: 15px 0;
  font-family: 'Dancing Script', cursive;
  color: #333;
}

.nombre-novioo {
  font-size: 24px;
  font-family: 'Dancing Script', cursive;
  color: #333;
}

.novia {
  font-size: 24px;
  font-family: 'Dancing Script', cursive;
  color: #333;
}

.starlove {
  font-family: 'Starlove', cursive;
  font-size: 44px;
  color: #93806d;
  margin-top: -30px;
}

/* Ornamento */
.ornamento-container {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease;
  margin-top: 30px;
  margin-left: 20px;
  align-self:flex-start;
}

.ornamento-img {
  width: 150px;
  height: auto;
}

/* Bendición alineada a la izquierda */
.bendicion-container-izq {
  text-align: center;
  align-self: center;
  margin-left: 20px;
  margin-top: 0px;
  margin-bottom: 20px;
  z-index: 2;
  position: relative;
}

.bendicion-subtitulo {
  font-family: 'corinthia';
  font-size: 38px;
  margin: 0;
  color: #897850;
}

.bendicion-titulo {
  font-family: 'Playfair Display', serif;
  font-size: 28px;
  font-weight: 400;
  margin-top: -5px;
  color: #897850;
}

/* Fondo padres */
.padres-fondo {
  position: relative;
  width: 100%;
  overflow: hidden;
  margin-top: 10px;
}

.padres-background {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(219, 213, 213, 0.1) 30%, rgba(227, 227, 221, 0.2));
  z-index: 1;
}

/* Contenedor padres */
.padres-fotos-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  padding: 30px 20px;
  position: relative;
  z-index: 2;
  gap: 30px;
}

/* Tarjeta padre */
.padre-card {
  max-width: 260px;
  text-align: center;
  opacity: 0;
  transition: all 0.8s ease;
}

.padre-card.left {
  transform: translateX(-50px);
}

.padre-card.right {
  transform: translateX(50px);
}

.padre-card.animate__animated {
  opacity: 1;
  transform: translateX(0);
}

.padre-img {
  width: 100%;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.padre-nombres {
  font-family: 'Playfair Display', serif; /* o tu fuente real 'fa' si está bien definida */
  font-size: 18px;
  color: #333;
  margin-top: 10px;
  margin-bottom: 5px;
  letter-spacing: 0px; /* 👈 elimina el espaciado extra */
}
.decorative-line {
  width: 70%;
  height: 1px;
  background-color: #ddd;
  opacity: 0.6;
  margin-left:20px;
  margin-right: 20px;
  align-self: center;
}


.padre-label {
  font-family: 'Playfair Display', serif; /* tipografía elegante */
  font-size: 14px;
  color: #7a6e58;
  background-color: #ffffff;
  display: inline-block;
  padding: 6px 20px;
  border-radius: 0;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-top: 5px;
  border: 1px solid #e0dcd4; /* línea delgada si lo deseas */
}

</style>
